import React from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
import { ThumbUpOutlined } from '@material-ui/icons';
import { BackLink } from '@components/BackLink/BackLink';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'grid',
		gridTemplateColumns: '1fr 11fr 4fr',
		borderRadius: '4px',
		minHeight: '72px',
		alignItems: 'top',
		padding: theme.spacing(3),
		marginBottom: theme.spacing(2.5),
		width: '100%',
		boxShadow: theme.shadows[5],
		boxSizing: 'border-box',
	},
	title: {
		fontSize: '1.5rem',
		lineHeight: '1.5rem ',
		fontWeight: 500,
		paddingBottom: theme.spacing(2),
	},
	subtitle: {
		fontSize: '1.125rem',
		lineHeight: '1.5',
		fontWeight: 500,
	},
	backLink: {
		marginTop: '-10px'
	}
}));

interface BlockReleaseCaughtUpMessageProps {
	navBackEnabled?: boolean;
	message?: string;
}

export const BlockReleaseCaughtUpMessage: React.FC<BlockReleaseCaughtUpMessageProps> = ({ navBackEnabled = false, message }) => {
	const classes = useStyles();

	return (
		<Box className={classes.root}>
			<ThumbUpOutlined />
			<Box>
				<Typography className={classes.title}>You&apos;re all caught up</Typography>
				<Typography className={classes.subtitle}>
					{message}
				</Typography>
			</Box>
			<Box className={classes.backLink}>
				{ navBackEnabled && <BackLink navBackText="BACK TO CASE LIST" />}
			</Box>
		</Box>
	);
};
